import { useEffect, useState } from "react";

// Internal Imports
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import IGroupKey from "../interfaces/IGroupKey";
import { GetListTypeQuestion } from "../services/form";



const useListTypeQuestion = () => {

    // States
    const [listTypeQuestion, setListTypeQuestion] = useState<IGroupKey[]>([]);
    const [loadingTypesQuestion, setLoadingTypesQuestion] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetTypeQuestion();
    }, [])

    // Handles
    const handleGetTypeQuestion = () => {
        setLoadingTypesQuestion(true);
        tryCatch(() => {
            GetListTypeQuestion()
                .then((response) => {
                    setListTypeQuestion(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingTypesQuestion(false));
        })
    }

    return {
        listTypeQuestion,
        loadingTypesQuestion,
        setListTypeQuestion
    }
}


export default useListTypeQuestion;